import { render, staticRenderFns } from "./AsCause.vue?vue&type=template&id=d5d0cd18&scoped=true"
import script from "./AsCause.vue?vue&type=script&lang=js"
export * from "./AsCause.vue?vue&type=script&lang=js"
import style0 from "./AsCause.vue?vue&type=style&index=0&id=d5d0cd18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d0cd18",
  null
  
)

export default component.exports